/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { SelfServiceAPI } from 'types';
import { getBookingDetailsPageLink } from 'lib/links';

export const useCanRequestAmendDatesGuard = (booking: SelfServiceAPI.Booking) => {
  const { replace } = useHistory();

  useEffect(() => {
    if (!booking.flags.isChangeDatesRequestEnabled) {
      replace(getBookingDetailsPageLink(booking.id));
    }
  }, []);
};
